/* ============================
   CART FORM HANDLING (gefixt, zelfde gedrag)
============================ */
if (typeof CartForm !== 'function') {

  class CartForm extends HTMLElement {

    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');
      if (!this.form) return; // guard

      this.querySelectorAll('[data-js-cart-item]').forEach(item => {

        // --- verwijderknop
        const remove = item.querySelector('.remove');
        if (remove) {
          const href = remove.getAttribute('href') || remove.dataset.href || '';
          remove.dataset.href = href;
          remove.setAttribute('href', '');
          remove.addEventListener('click', e => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        // --- quantity input
        const qty = item.querySelector('.qty');
        if (qty) {
          qty.addEventListener('input', debounce(e => {
            e.preventDefault();
            e.target.blur();
            const val = parseInt(qty.value || '0', 10);
            this.updateCartQty(item, isNaN(val) ? 1 : val);
          }, 500));
          qty.addEventListener('click', e => {
            e.target.select();
          });
        }

      });
    }

    updateCartQty(item, newQty) {
      if (!item) return;

      let alert = null;
      this.form = this.form || this.querySelector('form');
      if (this.form) this.form.classList.add('processing');
      const existingAlert = this.querySelector('.alert');
      if (existingAlert) existingAlert.remove();

      const body = JSON.stringify({
        line: parseInt(item.dataset.line || '0', 10),
        quantity: newQty
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body
      })
        .then(response => response.json().catch(() => ({})))
        .then(response => {
          if (response && response.status == 422) {
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            alert.innerHTML = typeof response.description === 'string'
              ? response.description
              : (response.message || 'Er ging iets mis.');
          }
          return fetch('?section_id=helper-cart');
        })
        .then(response => response.text())
        .then(text => {

          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
          const newFormHost = sectionInnerHTML.getElementById('AjaxCartForm') || sectionInnerHTML.querySelector('cart-form');
          const newSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

          const cartItems = document.getElementById('AjaxCartForm') || this; // fallback naar huidige host
          if (cartItems && newFormHost) {
            cartItems.innerHTML = newFormHost.innerHTML;
            // Na replace opnieuw binden als methode bestaat
            if (typeof cartItems.ajaxifyCartItems === 'function') {
              cartItems.ajaxifyCartItems();
            } else {
              const cf = cartItems.closest('cart-form');
              if (cf && typeof cf.ajaxifyCartItems === 'function') cf.ajaxifyCartItems();
            }
          }

          // update header count / total (guards)
          const countSrc = (cartItems && cartItems.querySelector('[data-cart-count]')) || document.querySelector('[data-cart-count]');
          const totalSrc = (cartItems && cartItems.querySelector('[data-cart-total]')) || document.querySelector('[data-cart-total]');
          if (countSrc) document.querySelectorAll('[data-header-cart-count]').forEach(elm => { elm.textContent = countSrc.textContent; });
          if (totalSrc) document.querySelectorAll('[data-header-cart-total]').forEach(elm => { elm.textContent = totalSrc.textContent; });

          if (alert !== null && this.form) this.form.prepend(alert);

          if (newSubtotal) {
            const targetSubtotal = document.getElementById('AjaxCartSubtotal');
            if (targetSubtotal) targetSubtotal.innerHTML = newSubtotal.innerHTML;
          }

          // minus-knop status updaten
          toggleMinusButtons(cartItems || document);

          const event = new Event('cart-updated');
          this.dispatchEvent(event);
        })
        .catch(e => {
          console.log(e);
          let alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = (KROWN && KROWN.settings && KROWN.settings.locales && KROWN.settings.locales.cart_general_error) || 'Er ging iets mis.';
          if (this.form) this.form.prepend(alert);
        })
        .finally(() => {
          if (this.form) this.form.classList.remove('processing');
        });
    }
  }

  if (typeof customElements.get('cart-form') == 'undefined') {
    customElements.define('cart-form', CartForm);
  }
}

/* ============================
   CART PRODUCT QUANTITY
============================ */
if (typeof CartProductQuantity !== 'function') {

  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();

      this.minusBtn = this.querySelector('.qty-minus');
      this.plusBtn = this.querySelector('.qty-plus');
      this.qtyInput = this.querySelector('.qty');

      // voorkom standaard form/navigatie
      this.querySelectorAll('button, input').forEach(el => {
        el.addEventListener('click', e => e.preventDefault());
      });

      if (this.minusBtn) this.minusBtn.addEventListener('click', this.changeCartInput.bind(this));
      if (this.plusBtn) this.plusBtn.addEventListener('click', this.changeCartInput.bind(this));

      this.toggleMinusButton();
    }

    changeCartInput(e) {
      // her-grab bij DOM refresh
      if (!this.qtyInput) this.qtyInput = this.querySelector('.qty');
      if (!this.qtyInput) return;

      const isPlus = e.currentTarget.classList.contains('qty-plus');
      const isMinus = e.currentTarget.classList.contains('qty-minus');
      let current = parseInt(this.qtyInput.value || '1', 10);
      if (isNaN(current) || current < 1) current = 1;

      // wijzig lokale waarde vóór we AJAX doen
      if (isPlus) current += 1;
      if (isMinus && current > 1) current -= 1;

      this.qtyInput.value = current;

      // verberg minus bij 1
      this.toggleMinusButton();

      // stuur update naar Shopify
      const cartForm = this.closest('cart-form') || document.getElementById('AjaxCartForm');
      if (cartForm && typeof cartForm.updateCartQty === 'function') {
        cartForm.updateCartQty(this.closest('[data-js-cart-item]'), current);
      }
    }

    toggleMinusButton() {
      if (!this.minusBtn || !this.qtyInput) return;
      const qty = parseInt(this.qtyInput.value || '1', 10);
      const hide = qty <= 1;
      this.minusBtn.style.visibility = hide ? 'hidden' : 'visible';
      this.minusBtn.disabled = hide;
      this.minusBtn.setAttribute('aria-disabled', hide ? 'true' : 'false');
    }
  }

  if (typeof customElements.get('cart-product-quantity') == 'undefined') {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}


/* ============================
   HELPER: minus-knoppen updaten
============================ */
function toggleMinusButtons(root = document) {
  (root || document).querySelectorAll('cart-product-quantity').forEach(el => {
    if (typeof el.toggleMinusButton === 'function') el.toggleMinusButton();
  });
}

/* ============================
   REFRESH CART (apps)
============================ */
if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch('?section_id=helper-cart')
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const newFormHost = sectionInnerHTML.getElementById('AjaxCartForm') || sectionInnerHTML.querySelector('cart-form');
        const cartSubtotalInnerHTML = (sectionInnerHTML.getElementById('AjaxCartSubtotal') || {}).innerHTML;

        const cartItems = document.getElementById('AjaxCartForm') || document.querySelector('cart-form');
        if (cartItems && newFormHost) {
          cartItems.innerHTML = newFormHost.innerHTML;
          if (typeof cartItems.ajaxifyCartItems === 'function') cartItems.ajaxifyCartItems();
          else cartItems.closest('cart-form')?.ajaxifyCartItems?.();
        }

        if (cartSubtotalInnerHTML) {
          const sub = document.getElementById('AjaxCartSubtotal');
          if (sub) sub.innerHTML = cartSubtotalInnerHTML;
        }

        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          const src = (cartItems && cartItems.querySelector('[data-cart-count]')) || document.querySelector('[data-cart-count]');
          if (src) elm.textContent = src.textContent;
        });
        document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
          const src = (cartItems && cartItems.querySelector('[data-cart-total]')) || document.querySelector('[data-cart-total]');
          if (src) elm.textContent = src.textContent;
        });

        if (document.querySelector('[data-js-site-cart-sidebar]')) {
          document.querySelector('[data-js-site-cart-sidebar]').show();
        }

        const rec = document.querySelector('cart-recommendations');
        if (rec && typeof rec.generateRecommendations === 'function') {
          rec.innerHTML = '';
          rec.generateRecommendations();
        }

        toggleMinusButtons(cartItems || document);
      });
  };
}

/* ============================
   CART NOTE
============================ */
if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            const url = (KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_update_url) || '/cart/update.js';
            fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
              body
            });
          }, 150)
        );
      }
    }
  );
}

/* ============================
   CART DISCOUNTS
============================ */
if (!customElements.get('cart-discounts')) {
  customElements.define(
    'cart-discounts',
    class CartDiscounts extends HTMLElement {
      constructor() {
        super();

        const button = this.querySelector('[data-js-discount-submit]');
        this.input = this.querySelector('[data-js-discount-input]');
        this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
        this.cartDiscountError = this.querySelector('[data-js-discount-error]');
        this.discountCodes = document.querySelector('[data-js-discount-codes]');

        this.loadDiscountButtons();

        if (button) {
          button.addEventListener('click', e => {
            e.preventDefault();
            if (this.input && this.input.value.length > 0) {
              this.cartSubtotal?.classList.add('processing');
              if (this.discountCodes) this.discountCodes.classList.add('processing');

              const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
              const allDiscounts = [...existingDiscounts, this.input.value];
              const discountString = allDiscounts.join(',');
              const body = JSON.stringify({ discount: discountString });

              fetch(`${KROWN.settings.routes.cart_update_url}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body
              })
                .then(response => response.json().catch(() => ({})))
                .then(response => {
                  const discountCodes = response.discount_codes || [];
                  const inputValue = this.input.value;
                  const matchingCode = discountCodes.find(code => code.code === inputValue);
                  if (matchingCode) {
                    if (matchingCode.applicable) {
                      this.handleSuccess();
                    } else {
                      this.handleError();
                    }
                  } else {
                    this.handleError();
                  }
                })
                .catch(error => {
                  this.handleError();
                  console.log(`Error: ${error}`);
                });
            }
          });
        }
      }

      handleSuccess() {
        fetch('?section_id=helper-cart')
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
            const cartSubtotalEl = sectionInnerHTML.getElementById('AjaxCartSubtotal');
            if (cartSubtotalEl && this.cartSubtotal) this.cartSubtotal.innerHTML = cartSubtotalEl.innerHTML;
            this.cartSubtotal?.classList.remove('processing');
            if (this.cartDiscountError) this.cartDiscountError.innerHTML = '';
            const codes = sectionInnerHTML.querySelector('[data-js-discount-codes]');
            if (codes && this.discountCodes) {
              this.discountCodes.innerHTML = codes.innerHTML;
              this.discountCodes.classList.remove('processing');
              this.loadDiscountButtons();
            }
            if (this.input) this.input.value = '';
          });
      }

      loadDiscountButtons() {
        this.querySelectorAll('[data-js-discount]').forEach(elm => {
          if (!elm.classList.contains('enabled')) {
            elm.classList.add('enabled');
            elm.addEventListener('click', e => {
              e.preventDefault();
              this.cartSubtotal?.classList.add('processing');
              if (this.discountCodes) this.discountCodes.classList.add('processing');
              const discountToRemove = elm.dataset.jsDiscount;
              const allDiscountElements = this.querySelectorAll('[data-js-discount]');
              const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
              const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
              const body = JSON.stringify({ discount: remainingDiscounts.join(',') });
              fetch(`${KROWN.settings.routes.cart_update_url}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body
              })
                .then(() => {
                  this.handleSuccess();
                })
                .catch(error => {
                  console.error(`Error: ${error}`);
                });
            });
          }
        });
      }

      handleError() {
        this.cartSubtotal?.classList.remove('processing');
        if (this.discountCodes) this.discountCodes.classList.remove('processing');
        if (this.cartDiscountError) this.cartDiscountError.innerHTML = (window.KROWN?.settings?.locales?.cart_discount_code_error) || 'Kortingscode ongeldig.';
      }
    }
  );
}
